import { type ReactElement } from 'react';
import styles from './select-country.module.scss';
import ReactSelect from 'react-select';
import { useTranslation } from 'next-i18next';
import { Flag } from '@utmb/design-system/flag/Flag';
import { Font } from '@utmb/design-system/text/font';

export interface SelectCountryProps {
    countries: {
        value: string;
        label: string;
    }[];
    value?: { value: string; label: string };
    onChange: (value: { value: string; label: string }) => void;
    label?: string;
    require?: boolean;
}

export function SelectCountry({ countries, value, onChange, label, require }: SelectCountryProps): ReactElement {
    const { t } = useTranslation();
    return (
        <>
            {label && (
                <Font.OxaniumRegular as="span" mobile="12" desktop="12" className={styles.label}>
                    <label>
                        {label}
                        {require ? ' *' : ''}
                    </label>
                </Font.OxaniumRegular>
            )}
            <ReactSelect
                className={`${styles.customCountrySelect}`}
                classNamePrefix="react-select"
                placeholder={t('common.selectCountry')}
                isMulti={false}
                value={value}
                options={countries}
                onChange={(data) => onChange({ label: data!.label, value: data!.value })}
                isSearchable={true}
                noOptionsMessage={() => t('common.noResult')}
                formatOptionLabel={(option: any) => (
                    <div className={styles.item}>
                        <div className={styles.flag_wrapper}>
                            <Flag isoCode={option.value} />
                            <Font.FuturaBook className={`${styles.filter_label} ${styles.flag_label}`}>{option.label}</Font.FuturaBook>
                        </div>
                    </div>
                )}
            />{' '}
        </>
    );
}
